import clsx from "clsx"
import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { SpinnerComponent } from "../../../../lib/spinner"
import { LogoSpinnerComponent } from "../../../../lib/spinner/spinnerLogo"
import { DownloadIcon } from "../../../../ui/icons/DownloadIcon"
import { EditIcon } from "../../../../ui/icons/edit"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { formatterDate, statusLiberatoria, yearOptions } from "../../../../utils"
import { EditLiberatoria } from "../edit"
import '../style.scss'
import { DownloadWaiverToCodexDoc, GetAllWaiverToCodex, resetWaiverCreateStatus, resetWaiverFilters, resetWaiverRequest, resetWaiverUpdateStatus, setAllowedDepartureProtocolId, setBreakoutDate, setCompletePassing, setCustomerId, setDeniedDepartureProtocolId, setEntryProtocol, setExpirationDate, setFieldsPassing, setIdWaiver, setNote, setNotificationChangeProtocolId, setOdc, setProtocolDate, setSenderOrReceiver, setSendingDossier, setStatusFilter, setSubmissionNotificationOdcDate, setYearFilter } from "./dataService/slice"

interface LiberatorieToCodexProps {
    showPopupToAdd: boolean
    setShowPopupToAdd: (value: boolean) => void
}

export function LiberatorieToCodex({ showPopupToAdd, setShowPopupToAdd }: LiberatorieToCodexProps) {
    const dispatch = useAppDispatch()
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const waiverToState = useAppSelector(state => state.waiverToCodex)

    useEffect(() => {
        const currentYear = new Date().getFullYear().toString()
        dispatch(GetAllWaiverToCodex({
            page: 0,
            itemsPerPage: 0,
            year: currentYear
        }))
    }, [waiverToState.getAllWaiverToFilters])

    useEffect(() => {
        if (waiverToState.CreateWaiverToCodexStatus === 'successfully') {
            dispatch(GetAllWaiverToCodex(waiverToState.getAllWaiverToFilters))
            dispatch(resetWaiverUpdateStatus())
            if (showPopupToAdd) {
                setShowPopupToAdd(false)
            }
            dispatch(resetWaiverRequest())
            setShowSuccess(true)
            setTimeout(() => {
                setShowSuccess(false)
            }, 2500);
        }
    }, [waiverToState.CreateWaiverToCodexStatus])

    useEffect(() => {
        if (waiverToState.UpdateWaiverToCodexStatus === 'successfully') {
            dispatch(GetAllWaiverToCodex(waiverToState.getAllWaiverToFilters))
            dispatch(resetWaiverCreateStatus())
            dispatch(resetWaiverRequest())
            setShowPopup(false)
            setShowSuccess(true)
            setTimeout(() => {
                setShowSuccess(false)
            }, 2500);
        }
    }, [waiverToState.UpdateWaiverToCodexStatus])

    const handleOnEdit = (w: any) => {
        dispatch(setCompletePassing(w.completePassing))
        dispatch(setFieldsPassing(w.fieldsPassing))
        dispatch(setAllowedDepartureProtocolId(w.allowedDepartureProtocolId))
        dispatch(setDeniedDepartureProtocolId(w.deniedDepartureProtocolId))
        dispatch(setBreakoutDate(w.breakoutDate))
        dispatch(setExpirationDate(w.expirationDate))
        dispatch(setSendingDossier(w.sendingDossier))
        dispatch(setNote(w.note))
        dispatch(setOdc(w.odcReference))
        dispatch(setEntryProtocol(w.entryProtocolId))
        dispatch(setCustomerId(w.customerId))
        dispatch(setSenderOrReceiver(w.waiverInnerInfo.senderOrReceiver))
        dispatch(setProtocolDate(w.waiverInnerInfo.protocolDate))
        dispatch(setNotificationChangeProtocolId(w.notificationChangeProtocolId))
        dispatch(setSubmissionNotificationOdcDate(w.submissionNotificationOdcDate))
        dispatch(setIdWaiver(w.id))
        setShowPopup(true)
    }


    if (waiverToState.downloadDocStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    if (waiverToState.GetAllWaiverToCodexStatus === 'loading') {
        return (
            <SpinnerComponent size={'large'} />
        )
    }

    if (waiverToState.downloadExcelStatus === 'loading') {
        return (
            <SpinnerComponent size={'large'} />
        )
    }

    return (
        <div style={{ padding: '24px' }}>
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '18px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div className="flex flex-col gap-4">
                <div className="flex flex-row gap-2 items-center">
                    <MadfarmStaticSelect
                        placeholder={'Seleziona Anno'}
                        options={yearOptions}
                        value={waiverToState.getAllWaiverToFilters.year}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setYearFilter(newValue))

                        }}
                        noOptionsMessage=""
                    />
                    <MadfarmStaticSelect
                        placeholder={'Seleziona Stato'}
                        options={statusLiberatoria}
                        value={waiverToState.getAllWaiverToFilters.status}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setStatusFilter(newValue))

                        }}
                        noOptionsMessage=""
                    />

                    <div className="flex flex-row items-center gap-2 w-[20%]">
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Pulisci"
                            color={"gray"}
                            onClick={() => dispatch(resetWaiverFilters())}
                        />
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Cerca"
                            color={"orange"}
                            onClick={() => dispatch(GetAllWaiverToCodex(waiverToState.getAllWaiverToFilters))}
                        />
                    </div>
                </div>

                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-sm">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Sede</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Protocollo</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Numero Protocollo</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Mittente</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Regione</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Provincia</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cliente</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cod. Cliente</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Recesso</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Scadenza</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Evaso</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipologia Liberatoria</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Liberatoria Negata/Concessa</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Note</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[60px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(waiverToState.getAllWaiverToResponse?.data || []).length === 0 ? (
                                <tr>
                                    <td colSpan={15} className="px-3 py-4 text-center text-neutral-500 bg-white">
                                        Nessuna liberatoria trovata
                                    </td>
                                </tr>
                            ) : (
                                (waiverToState.getAllWaiverToResponse?.data || []).map((w, index) => (
                                    <tr
                                        key={w.id ?? index}
                                        className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-blue-800 font-semibold whitespace-nowrap">
                                            {w.waiverInnerInfo.headQuarter}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                            {formatterDate(w.waiverInnerInfo.protocolDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.protocolNumber}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.senderOrReceiver}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.region}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.province}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.companyName}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.clientCode}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                            {formatterDate(w.waiverInnerInfo.endingDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                            {formatterDate(w.expirationDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {statusLiberatoria.filter(({ value }) => value === w.breakoutType).map(el => (
                                                <span key={el.value} className={clsx("labelStatus", { "nonEvasa": w.breakoutType === 'NON_EVASA', "evasa": w.breakoutType === 'EVASA' })}> {el.label}</span>
                                            ))}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            Liberatoria per cambio OdC
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.allowedDepartureProtocolId && (
                                                <span>{w.allowedDepartureProtocolInfo}</span>
                                            )}
                                            {w.deniedDepartureProtocolId && (
                                                <span>{w.deniedDepartureProtocolInfo}</span>
                                            )}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.note}
                                        </td>
                                        <td className="px-3 py-2 w-[60px]">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => {
                                                        handleOnEdit(w)
                                                    }}
                                                >
                                                    <EditIcon color={"Orange"} size={18} />
                                                    <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                        Modifica Liberatoria
                                                    </span>
                                                </button>

                                                <button
                                                    className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => {
                                                        dispatch(DownloadWaiverToCodexDoc(w.id))
                                                    }}
                                                >
                                                    <DownloadIcon size="36" color={"Orange"} />
                                                    <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                        Scarica Documento
                                                    </span>
                                                </button>
                                            </div>

                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {
                showPopup && (
                    <PopupForm title="Modifica Liberatoria" close={() => setShowPopup(false)}>
                        <EditLiberatoria close={() => { setShowPopup(false); dispatch(resetWaiverRequest()) }} type="to" />
                    </PopupForm>
                )
            }
        </div>
    )
}